import { TORUS_KNOT } from '@/constants/object';
import * as THREE from 'three';
import { BaseObject, applyProperties } from './base';

export class TorusKnot extends BaseObject {
  constructor() {
    super(
      new THREE.TorusKnotGeometry(
        TORUS_KNOT.RADIUS,
        TORUS_KNOT.TUBE,
        TORUS_KNOT.TUBULAR_SEGMENTS,
        TORUS_KNOT.RADIAL_SEGMENTS
      ),
      new THREE.MeshStandardMaterial({ color: TORUS_KNOT.COLOR })
    );

    this.radius = TORUS_KNOT.RADIUS;
    this.tube = TORUS_KNOT.TUBE;
    this.radialSegments = TORUS_KNOT.RADIAL_SEGMENTS;
    this.tubularSegments = TORUS_KNOT.TUBULAR_SEGMENTS;

    this.getOutline();

    this.updateGeometry = () => {
      this.geometry.dispose();
      this.geometry = new THREE.TorusKnotGeometry(this.radius, this.tube, this.tubularSegments, this.radialSegments);
      this.getOutline();
    };

    this.applyProperties = (properties) => {
      applyProperties(this, properties, false);
      let needsUpdate = false;

      if ('radius' in properties && properties.radius !== this.radius) {
        this.userData.data.radius = properties.radius;
        this.radius = properties.radius;
        needsUpdate = true;
      }
      if ('tube' in properties && properties.tube !== this.tube) {
        this.userData.data.tube = properties.tube;
        this.tube = properties.tube;
        needsUpdate = true;
      }
      if ('radialSegments' in properties && properties.radialSegments !== this.radialSegments) {
        this.userData.data.radialSegments = properties.radialSegments;
        this.radialSegments = properties.radialSegments;
        needsUpdate = true;
      }
      if ('tubularSegments' in properties && properties.tubularSegments !== this.tubularSegments) {
        this.userData.data.tubularSegments = properties.tubularSegments;
        this.tubularSegments = properties.tubularSegments;
        needsUpdate = true;
      }

      if (needsUpdate) this.updateGeometry();
    };
  }
}
